
// 处理流数据，拆分各个模块
export function splitResponseByModulesEnhanced(response, splitMarkers) {
  const result = {};

  // 验证输入
  if (!response || !Array.isArray(splitMarkers) || splitMarkers.length === 0) {
    return result;
  }

  for (let i = 0; i < splitMarkers.length; i++) {
    const currentMarker = splitMarkers[i];

    // 提取标签名称，如从'<需求概述></需求概述>'中提取'需求概述'
    const tagName = currentMarker.replace('<', '').replace('></', '>').split('>')[0];
    const startTag = `<${tagName}>`;
    const endTag = `</${tagName}>`;

    let content = '';

    // 查找开始标签位置
    const startIndex = response.indexOf(startTag);
    if (startIndex === -1) {
      console.warn(`未找到开始标签: ${startTag}`);
      result[tagName] = '';
      continue;
    }

    // 查找结束标签位置
    const endIndex = response.indexOf(endTag, startIndex + startTag.length);
    if (endIndex === -1) {
      console.warn(`未找到结束标签: ${endTag}`);
      result[tagName] = '';
      continue;
    }

    // 提取内容
    content = response.substring(startIndex + startTag.length, endIndex).trim();
    result[tagName] = content;
  }

  return result;
}
